import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightToArc, faArrowRightFromArc, faCircleUser, faGavel, faClockRotateLeft, faBars } from '@fortawesome/pro-regular-svg-icons'
import { Dropdown, MenuItem } from 'react-bootstrap'

import CreditLimit from '../creditLimit'
import MediaQuery from 'react-responsive'

const WelcomeMessage = () => {
  const match = useRouteMatch('/auctions/:auctionUuid')
  const auctionUuid = match?.params?.auctionUuid
  const user = useSelector(state => state.users.user)
  const userUuid = user?.uuid
  const registrations = useSelector(state => state.registrations.registrantIdsByUserUuidByAuction[auctionUuid], shallowEqual)
  const registration = userUuid && registrations?.[userUuid]
  const displayName = user?.forename ? user?.forename : user?.displayName || ''
  const paddleNumber = user?.username ? user?.username.replace('mmuser0', '') : ''

  const creditLimitHtml = !!userUuid && (
    <div className='woa-welcome-bar x-bidlogix--authenticated-show'>
      <div className='woa-welcome-message'>
        <span className='woa-bidder__display-message'>Welcome</span> <span className='woa-bidder__display-name'>{displayName}</span> <span className='woa-bidder__paddle-number'>{paddleNumber}</span>
      </div>
      <CreditLimit
        auctionUuid={auctionUuid}
        isRegistered={!!registration?.approved}
      />
    </div>
  )

  return (
    <div className='auction-navigation'>
      <MediaQuery maxWidth={1199}>
        {creditLimitHtml}
        <Dropdown className='woa-auction-nav--mobile' id='woa-auction-nav--mobile' pullRight>
          <Dropdown.Toggle variant='success' id='woa-auction-nav--mobile-toggle'>
            <FontAwesomeIcon icon={faBars} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem href='#!/'><FontAwesomeIcon icon={faGavel} /> Current Auctions</MenuItem>
            <MenuItem href='#!/auctionsArchived'><FontAwesomeIcon icon={faClockRotateLeft} /> Past Auctions</MenuItem>
            {!userUuid &&
            <MenuItem href='#!/login'><FontAwesomeIcon icon={faArrowRightToArc} /> Login</MenuItem>
            }
            {!!userUuid &&
            <>
              <MenuItem href='#!/account'><FontAwesomeIcon icon={faCircleUser} /> My Account</MenuItem>
              <MenuItem href='#!/logout'><FontAwesomeIcon icon={faArrowRightFromArc} /> Log Out</MenuItem>
            </>
            }
          </Dropdown.Menu>
        </Dropdown>
      </MediaQuery>
      <MediaQuery minWidth={1200}>
        <nav className='woa-auction-nav'>
          <ul className='woa-auction-nav--desktop navbar-nav nav' role='navigation'>
            <li><a href='#!/'><FontAwesomeIcon icon={faGavel} /> Current Auctions</a></li>
            <li><a href='#!/auctionsArchived'><FontAwesomeIcon icon={faClockRotateLeft} /> Past Auctions</a></li>
            <li>{creditLimitHtml}</li>
            {!userUuid &&
            <li><a href='#!/login'><FontAwesomeIcon icon={faArrowRightToArc} /> Login</a></li>
            }
            {!!userUuid &&
            <>
              <li><a href='#!/account'><FontAwesomeIcon icon={faCircleUser} /> My Account</a></li>
              <li><a href='#!/logout'><FontAwesomeIcon icon={faArrowRightFromArc} /> Log Out</a></li>
            </>
            }
          </ul>
        </nav>
      </MediaQuery>
    </div>
  )
}

export default WelcomeMessage
